import React, { useCallback, useEffect, useState } from 'react';
import { Dropdown } from 'reactstrap';
import '../FilterOptions.css';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../context';
import AssignableUserList from './AssignableUserList';

const AssignedPracticeFilter = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.practice.setActiveTabPractices('active'));
        return () => dispatch(actions.practice.getAssignedUser(null));
    }, [dispatch]);

    const [isOpen, setIsOpen] = useState(false);
    const toggleOpen = useCallback(() => setIsOpen(!isOpen), [isOpen]);

    return (
        <div className={`text-light d-flex justify-content-center`}>
            <h4 className="d-inline text-right pt-1">Assigned to:&emsp;</h4>
            <Dropdown isOpen={isOpen} toggle={toggleOpen}>
                <AssignableUserList />
            </Dropdown>
        </div>
    );
};

export default AssignedPracticeFilter;
